<script>
import {TokenMixin} from '@/assets/js/mixins/token-mixin';
import _ from "lodash";
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: 'DeleteDestroyVm',
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  emits: ['destroy', 'delete'],
  data() {
    return {
      deleteIps: 0,
    }
  },
  props: {
    selectedItemsList: {
      required: true,
      type: Array,
    },
    items: {
      required: true,
      type: Array,
    }
  },
  computed: {
    title() {
      if (this.selectedItemsList.length === 1) {
        return `Confirm delete or destroy VM: ${this.getCurrentItemForDelete().Name}`;
      } else {
        return `Confirm delete ${this.selectedItemsList.length} VMs`;
      }
    },
    msg() {
      if (this.selectedItemsList.length === 1) {
        return `What do you want to do?`;
      } else {
        return `Are you sure you want to delete  ${this.selectedItemsList.length} VMs?`;
      }
    },
    VmToDestroy() {
      const itemsToDestroy = []
      _.map(this.selectedItemsList, (itemId) => {
        const itemToDestroy = _.find(this.items, {Id: itemId, State: "poweredOff"})
        if (itemToDestroy !== undefined) {
          itemsToDestroy.push(itemToDestroy.Id)
        }
      })
      return itemsToDestroy;
    }
  },
  methods: {
    getCurrentItemForDelete() {
      return _.find(this.items, {Id: this.selectedItemsList[0]})
    },
    deleteAction() {
      this.$emit('delete', this.deleteIps)
      this.$modal.hide('DeleteOrDestroyVm')
    },
    destroyAction() {
      this.$emit('destroy', this.VmToDestroy, this.deleteIps)
      this.$modal.hide('DeleteOrDestroyVm')
    }
  }
}
</script>

<template>
  <modal
      name="DeleteOrDestroyVm"
      height="auto"
      width="550px"
  >
    <div class="window-header">
      {{ title }}
      <a href="javascript:void(0)" class="close-modal pull-right" @click="$modal.hide('DeleteOrDestroyVm')"><i
          class="fa fa-times"></i></a>
    </div>
    <div class="modal-body">
      {{ msg }}
      <b-form-checkbox
          v-model="deleteIps"
          value="1"
          unchecked-value=""
      >
        Do you want to delete assigned IPs?
      </b-form-checkbox>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" v-on:click="deleteAction()" type="button">
        <span>Delete from db</span>
      </button>
      <span  v-tippy="{arrow : true, onShow: () => VmToDestroy.length === 0 }" title="Please select VMs with State 'OFF' to destroy" >
      <button class="btn btn-destroy" :disabled="VmToDestroy.length === 0" v-on:click="destroyAction()" type="button">
        <span>DESTROY and remove vm data</span>
      </button>
      </span>
      <button class="btn" v-on:click="$modal.hide('DeleteOrDestroyVm')" type="button">
        <span>Cancel</span>
      </button>
    </div>
  </modal>
</template>

<style scoped>

</style>